type Direction = '→' | '←' | '•' | '⚠';

interface Entry {
  time: string;
  identity: string;
  direction: Direction;
  event: string;
  details: string;
}

const MAX = 1000;
const entries: Entry[] = [];
const listeners = new Set<() => void>();

function ts(): string {
  return new Date().toISOString().slice(11, 23);
}

function fmtDetails(details: Record<string, unknown> | undefined): string {
  if (!details) return '';
  const parts: string[] = [];
  for (const [k, v] of Object.entries(details)) {
    if (v === undefined || v === null) continue;
    parts.push(`${k}=${typeof v === 'object' ? JSON.stringify(v) : String(v)}`);
  }
  return parts.join(' ');
}

let identityProvider: () => string | null = () => null;
export function setIdentityProvider(fn: () => string | null) { identityProvider = fn; }

function add(direction: Direction, event: string, details?: Record<string, unknown>) {
  const entry: Entry = { time: ts(), identity: identityProvider() ?? '?', direction, event, details: fmtDetails(details) };
  entries.push(entry);
  if (entries.length > MAX) entries.shift();
  listeners.forEach((fn) => fn());
}

export const DebugLog = {
  out:  (event: string, details?: Record<string, unknown>) => add('→', event, details),
  in:   (event: string, details?: Record<string, unknown>) => add('←', event, details),
  info: (event: string, details?: Record<string, unknown>) => add('•', event, details),
  warn: (event: string, details?: Record<string, unknown>) => add('⚠', event, details),
  subscribe(fn: () => void) { listeners.add(fn); return () => listeners.delete(fn); },
  snapshot() { return entries.slice(); },
  clear() { entries.length = 0; listeners.forEach((fn) => fn()); add('•', 'LOG_CLEARED'); },
  asText() {
    const head =
      `# ASLgo debug log\n# Identity: ${identityProvider() ?? '(not signed in)'}\n` +
      `# Captured: ${new Date().toISOString()}\n# User-Agent: ${navigator.userAgent}\n` +
      `# Entries: ${entries.length}\n\n`;
    return head + entries.map((e) => `${e.time}  [${e.identity}]  ${e.direction} ${e.event}` + (e.details ? `  ${e.details}` : '')).join('\n') + '\n';
  },
};
